import { createMoment } from './create'
import { deleteMoment } from './delete'
import { readMoment, readCollection } from './read'
import { resourceObject } from './resourceObject'
import { updateMoment } from './update'

export const moments = {
  create: createMoment,
  readSingle: readMoment,
  readCollection,
  update: updateMoment,
  clientResource: resourceObject,
  delete: deleteMoment,
}

export type { UpdateMomentV3RequestBody } from './update'
